import ajax from './ajax.js';
// import Vue from "vue";
import VueRouter from "vue-router";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import store from "./store.js";

export let loginErrorHandler = (data) => {
    console.log(data);
    if (data.errormsg === "nosign") {
        store.commit("clearUser");
        location.href = "/index.html";
        return true;
    } else {
        return false;
    }
};


const vuecommon = {
    install(Vue) {
        Vue.use(VueRouter);
        Vue.use(ElementUI);

        Vue.prototype.ajax = ajax;
        Vue.prototype.ajax.setAjaxErrorHandlers(loginErrorHandler);
        Vue.config.productionTip = false;
    }
};

export default vuecommon;
